import React, { useCallback, useEffect, useState } from "react";
import { useAuth0 } from "../../../react-auth0-spa";
import config from "../../../api_config.json";
import { Badge, Space, Typography, Spin, Empty } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import DocScannerCard from "../../DocScanner/DocScannerCard";
import { useAppContext } from "../../../context";

const { Title } = Typography;

const OrgDocScanner = ({ orgId }) => {
  const [items, setItems] = useState([]);
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const { isProd } = useAppContext();
  const { getTokenSilently } = useAuth0();

  const fetchData = useCallback(
    async (from) => {
      const limit = 12;

      try {
        const token = await getTokenSilently();

        const response = await fetch(
          `${
            config.baseUrl[isProd ? "prod" : "dev"]
          }/doc-scanner-results/${orgId}?limit=${limit}${
            from ? `&from=${btoa(from)}` : ""
          }`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const responseData = await response.json();
        return responseData;
      } catch (error) {
        console.error(error);
        return { data: { items: [], lastEvaluatedKey: null } };
      }
    },
    [isProd, getTokenSilently, orgId],
  );

  useEffect(() => {
    setLoading(true);
    fetchData().then(({ data }) => {
      setItems(data.items);
      setLastEvaluatedKey(data.lastEvaluatedKey);
      setHasMore(Boolean(data.lastEvaluatedKey));
      setLoading(false);
    });
  }, [fetchData]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <Empty
        description="Nessun risultato Doc Scanner trovato per questa organizzazione"
        style={{ marginTop: "50px" }}
      />
    );
  }

  return (
    <div>
      <Title level={4} style={{ marginBottom: "20px" }}>
        <Space>
          Doc Scanner
          <Badge overflowCount={5000} count={items.length}></Badge>
        </Space>
      </Title>
      <InfiniteScroll
        dataLength={items.length}
        next={() => {
          fetchData(lastEvaluatedKey).then(({ data }) => {
            setLastEvaluatedKey(data.lastEvaluatedKey);
            setItems((currentItems) => currentItems.concat(data.items));
            setHasMore(Boolean(data.lastEvaluatedKey));
          });
        }}
        hasMore={hasMore}
        loader={
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin />
          </div>
        }
      >
        <div className="grid-container">
          {items.map((scanResult, index) => {
            const jsonData = scanResult.outputJsonDefunto
              ? JSON.parse(scanResult.outputJsonDefunto.replace("'", ""))
              : undefined;
            return (
              <DocScannerCard
                key={index}
                createdAt={scanResult.createdAt}
                input={scanResult.files}
                resultJson={jsonData}
                resultPdf={
                  scanResult.outputPdfS3Key &&
                  `${config.files[isProd ? "prod" : "dev"]}/${
                    scanResult.outputPdfS3Key
                  }`
                }
                error={
                  !scanResult.outputJsonDefunto && !scanResult.outputPdfS3Key
                }
                code={scanResult.requestType}
                orgLink={`/orgs/${scanResult.orgId}`}
                llmProvider={scanResult.llmProvider}
                llmModel={scanResult.llmModel}
              />
            );
          })}
        </div>
      </InfiniteScroll>
    </div>
  );
};

export default OrgDocScanner;
